export default __webpack_public_path__ + "static/media/image_webcam.04a952b2.jpeg";